import { render, staticRenderFns } from "./PatentParticipantsTab.vue?vue&type=template&id=229c0197"
import script from "./PatentParticipantsTab.vue?vue&type=script&lang=js"
export * from "./PatentParticipantsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports